module.exports = __webpack_public_path__ + "img/quotation-marks.6270c021.svg";